// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"21b4462dabf43384","713":"c2c35a054b0ec9de"}[chunkId] + ".js";
};